import type { AnimationDataV1 } from './types/v1';
import type { AnimationDataV2 } from './types/v2';

/**
 * V1 → V2. The "Custom" preset tile was removed, so persisted blobs whose
 * `selectedPresetId` was the `'custom'` sentinel need it stripped — there is
 * no preset matching that id anymore. Users who had progressed past the
 * DESCRIBE_STYLE stage with `'custom'` are sent back to re-pick a real
 * preset; users still on DESCRIBE_STYLE (or earlier in some hypothetical
 * future) stay where they are.
 */
export function v1ToV2(input: AnimationDataV1): AnimationDataV2 {
    const wasCustomPreset = input.selectedPresetId === 'custom';

    const { selectedPresetId, activeStageId, ...rest } = input;

    return {
        ...rest,
        version: 2,
        selectedPresetId: wasCustomPreset ? undefined : selectedPresetId,
        activeStageId: wasCustomPreset ? 'describe-style' : activeStageId,
    };
}
